type SkeletonCardLoadProps = {
    cardsCount: number
}

const SkeletonCardLoad = ({ cardsCount }: SkeletonCardLoadProps) => {

    return (
        <div className="row mb-3">
            {
                Array.from(Array(cardsCount).keys()).map(x => {
                    return (
                        <div className="col-12" key={x}>

                            <div className="card mb-2">
                                <div className="row g-0">

                                    <div className="col-12 col-md-9">
                                        <div className="card-body px-4">

                                            <div className="row placeholder-glow px-2">
                                                <span className="placeholder col-2 mb-2 rounded"></span>
                                            </div>

                                            <hr />

                                            <div className="row placeholder-glow px-2">
                                                <span className="placeholder col-12 mb-3 rounded"></span>
                                                <span className="placeholder col-12 mb-3 rounded"></span>
                                                <span className="placeholder col-12 mb-3 rounded"></span>
                                                <span className="placeholder col-12 mb-3 rounded"></span>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 col-md-3 bg-light p-2 d-flex flex-column justify-content-start">

                                        <div className="row mb-1 placeholder-glow px-2">
                                            <span className="placeholder col-2 bg-dark rounded"></span>
                                            <span className="placeholder col-2 bg-dark ms-1 rounded"></span>
                                        </div>

                                        <hr />

                                        <div className="row align-self-strech mb-auto mt-auto placeholder-glow px-4">
                                            <span className="placeholder col-12 rounded"></span>
                                        </div>

                                        <hr/>

                                        <div className="row mb-0 placeholder-glow px-2">
                                            <button className="btn btn-warning disabled placeholder col-12"></button>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    )
                })
            }
        </div>
    )
}

export default SkeletonCardLoad;